import { useQuery, useMutation } from "@tanstack/react-query";
import {
  fetch2,
  fetch3,
  fetch4,
  fetch5,
  fetch6,
} from "../commonApis/commonApis";
const url = process.env.REACT_APP_BASE_URL;

type WarehouseData = {
  id?:string;
  name: string;
  location: string;
  locationTwo?: string;
  country: string;
  district: string;
  zipCode: string;
  city: string;
  status?: boolean;
};

type CoverageData = {
  warehouseId?: string;
  coverageId?: string;
  covrageCountry?: string | null;
  covrageCity?: string | null;
  covrage: string;
  covrageName: string;
  status?: boolean;
};

type ClientStatus = {
  status: string;
};

interface ApiResponse {
  success: boolean;
  data: any;
  message?: string;
  statusCode?: number;
  statusMessage?: string;
  error?: any;
}

export const useCreateWarehouseMutation = () => {
  return useMutation({
    mutationFn: async (payload: WarehouseData) => {
      const res: ApiResponse = await fetch4(`${url}/api/warehouse/`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Warehouse Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Warehouse create request failed:", error.message);
    },
  });
};

export const useCreateCoverageMutation = () => {
  return useMutation({
    mutationFn: async (payload: CoverageData) => {
      const res: ApiResponse = await fetch4(`${url}/api/warehouse/coverage`, payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Warehouse Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Warehouse create request failed:", error.message);
    },
  });
};

export const useWarehouseListData = () => {
  return useQuery({
    queryKey: ["warehouseData"],
    queryFn: async () => {
      const res = await fetch3(`${url}/api/warehouse/`, "get");

      if (!res || !res.data) {
        return res.message
      }

      return res.data; // 👈 This returns your full user object
    },
    staleTime: 1000 * 60 * 5,
  });
};

export const useUpdateWarehouseMutation = () => {
  return useMutation({
    mutationFn: async (payload: WarehouseData) => {
      const res: ApiResponse = await fetch5(`${url}/api/warehouse/update-warehouse`, "PATCH", payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Warehouse Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Warehouse create request failed:", error.message);
    },
  });
};


export const useUpdateCoverageMutation = () => {
  return useMutation({
    mutationFn: async (payload: CoverageData) => {
      const res: ApiResponse = await fetch5(`${url}/api/warehouse/update-coverage`, "PATCH", payload);

      // Manually throw error if success is false
      if (!res.success) {
        throw res.message || "Something went wrong";
      }

      return res.data;
    },
    onSuccess: (data: any) => {
      console.log("✅ Warehouse Created successfully:", data);
    },
    onError: (error: any) => {
      console.error("❌ Warehouse create request failed:", error.message);
    },
  });
};